module.exports = __webpack_public_path__ + "img/1.c36f18f6.jpeg";